import Widget from "../widget.js";
import {ChartComponent} from "../../../chart-kit/toast-chart/ChartComponent.js";
import {addFilterEvent} from "../filter-popup/index.js";
import {getNoData} from "../../items/index.js";

export class WeeklyMyTaskWidget extends Widget {

    #option = {
        "chart": {
            "width": "auto",
            "height": "auto",
            "title": {"text": ''}
        },
        "series": {
            "stack": {"type": "normal"},
            "dataLabels": {"visible": true}
        },
        "theme": {
            "series": {
                "dataLabels": {
                    "fontSize": 10,
                    "fontWeight": 300,
                    "useSeriesColor": true,
                    "textBubble": {
                        "visible": true,
                        "paddingY": 3,
                        "paddingX": 6,
                    }
                }
            },
            "chart": {"backgroundColor": "#fffff"}
        },
        "legend": {"visible": false},
        "exportMenu": {"visible": false},
        "xAxis": {"tick": {"interval": 1}, "label": {"interval": 1}},
        "responsive": {"animation": false}
    }

    async setup(props) {
        if (!Mutil.isFunc('WIDGET_WEEKLY_MY_TASK')) return;

        Mutil.lib.getToastChart().then();
        return super.setup(props);
    }

    async getData() {
        let inputData = {
            END_DTTM: dayjs().add('1', 'day').format("YYYYMMDD"),
            PRIORITY: "'','0','1','2','3'",
            START_DT: "1=1",
            START_DTTM: dayjs().add(this.$props.FIL_END_DT_GUBUN * -1, 'month').format("YYYYMMDD"),
            START_TYPE: "ft.rgsn_dttm",
            STTS: "'0','1','2','3','4'",
            USER_LIST: `'${_USER_ID}'`,
            WIDGET_IDO: "DIDO_INSIGHT_TEMPLATE_R002In",
        }
        this.$props.data = await this.getDBData(inputData)
        return true;
    }

    async getDBData(inputData) {
        if (!this.$props.API_KEY) return;

        const {RETURN_JSON} = await Ajax.executeApi("INSIGHT_WIDGET_R002", {...inputData});
        this.$props.pageData.NEXT_YN = "N";
        return RETURN_JSON ? JSON.parse(RETURN_JSON) : {};
    }

    async render() {
        $(this.$target).html('')
        const chartComponent = new ChartComponent({
            items: this.$props.data.reverse(),
            INSIGHT_TEMPLATE_SRNO: '2',
            CHART_TYPE: 'area',
            CHART_OPTION: this.#option,
            defaultClass: 'widget-null-wrap'

        });
        this.$target.insertAdjacentElement('afterbegin', chartComponent.getElement());
        this.mounted.bind(this)
    }

    mounted() {
        super.mounted();

        const $t = $(this.$target);
        $t.find('.widget-article-list').removeClass('dash-pending')
        $t.find('.dash-num-pending').remove()

    }

    setEvent() {
        const $w = $(this.$target).closest('.js-filter-widget');
        addFilterEvent.bind(this)({$w, filterGb: "month_filter"})
    }

}

